import { ref } from 'vue'

export function useCoursesApi(baseUrl) {
  const courses = ref([])
  const loading = ref(false)
  const error = ref(null)

  const fetchCourses = async (params = {}) => {
    loading.value = true
    error.value = null

    try {
      const response = await axios.get(baseUrl, { params })
      courses.value = response.data
      return response.data
    } catch (err) {
      error.value = err.message
      console.error('Error fetching courses:', err)
      return []
    } finally {
      loading.value = false
    }
  }

  const fetchCoursesByPage = async (page, params = {}) => {
    return await fetchCourses({ ...params, page })
  }

  return {
    courses,
    loading,
    error,
    fetchCourses,
    fetchCoursesByPage
  }
}